import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

export function FAQ({ items }) {
  const { t } = useLang();
  const faqItems = items || t.faq.items;
  return (
    <section id="faq" data-testid="faq-section" className="relative bg-carbon py-20 md:py-28">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <Reveal className="mb-10 text-center">
          <Overline className="justify-center">{t.faq.overline}</Overline>
          <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-ice sm:text-4xl lg:text-5xl">
            {t.faq.title}
          </h2>
        </Reveal>

        <Reveal delay={0.05}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqItems.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-edge">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-display text-base font-semibold text-ice hover:no-underline [&[data-state=open]]:text-amber"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-steel">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
